module.exports = __webpack_public_path__ + "img/stock7.a62734bf.png";